import React, { Component } from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import DialogContentText from '@material-ui/core/DialogContentText';

import { withStyles } from '@material-ui/core/styles';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';

import firebase from 'firebase/app';
import 'firebase/firestore';

import DynamicLinkHelper from '../helpers/DynamicLinkHelper';

const styles = theme => ({
    root: {
      display: 'flex',
    },
    formControl: {
      margin: theme.spacing.unit * 3,
    },
    group: {
      margin: `${theme.spacing.unit}px 0`,
    },
  });

class ShareScore extends Component{

    shareDocRef = null;
    dynamicLinkHelper = null;
    
    constructor(props){
        super(props);
        this.state = {
            readOnlyControlState: "readonly",
            showCopyLink: false,
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleShareSubmit = this.handleShareSubmit.bind(this);        
    }

    componentDidMount(){
        // we start creating the dynamic link asap. so the short version is ready
        // when the user finish with the dialogs.
        const db = firebase.firestore();
        this.shareDocRef = db.collection("sharedLink").doc();
        this.dynamicLinkHelper = new DynamicLinkHelper(this.shareDocRef.id);
    }

    handleShareSubmit(event){
        event.preventDefault();
        const docId = this.props.docId;
        // copy state to const objects becuase state may change before the dbwrite.
        const isReadonly = this.state.readOnlyControlState === "readonly" ? true : false;        

        this.shareDocRef.set({
            accountID: docId,
            sharedBy:firebase.auth().currentUser.uid,
            accountName: this.props.accountName,
            shareTime: firebase.firestore.FieldValue.serverTimestamp(),
            readOnly: isReadonly,            
            })
            .then(() => {
                console.log('Document writen to shareDocs collection with id:', this.shareDocRef.id );
            })
            .catch((error) => {
                console.log("Error getting document or writing sharedoc:", error);
            });
        
        // change to the copy link dialog.
        this.setState({
            showCopyLink: true,
        });
    }

    handleChange = event => {
        this.setState({ readOnlyControlState: event.target.value });
        
    }

    handleClose = event => {
        event.preventDefault();
        this.props.handleCancel();
    }

    getShareDialog(){
        const { classes } = this.props;
        return (
            <div>
                <Dialog
                    open={true}
                    aria-labelledby="form-dialog-share"
                >
                    <DialogTitle id="form-dialog-share-title">Read only or read and write?</DialogTitle>
                    <DialogContent>

                        <RadioGroup
                            aria-label="Gender"
                            name="gender1"
                            className={classes.group}
                            value={this.state.readOnlyControlState}
                            onChange={this.handleChange}
                        >
                            <FormControlLabel value="readonly" control={<Radio />} label="With Kid( Read only)" />
                            <FormControlLabel value="readwrite" control={<Radio />} label="With spouse( Read and Write)" />                              
        
                        </RadioGroup>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.props.handleCancel} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.handleShareSubmit} color="primary">
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );           
    }
    
    getCopyLInkDialog(){
        const dlink = this.dynamicLinkHelper.getDynamicLink()
        return (
            <div>
                <Button onClick={this.handleClickOpen}>Open alert dialog</Button>
                    <Dialog
                    open={true}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    >
                    <DialogTitle id="alert-dialog-title">{"Send link to share."}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {dlink}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <CopyToClipboard text={dlink}>
                            <Button onClick={this.handleClose}>Copy to ClipBoard</Button>
                        </CopyToClipboard>
                        <Button onClick={this.handleClose}>
                        Close
                        </Button>
                    </DialogActions>
                    </Dialog>
            </div>
        );
    }
    
    render(){
        if (!this.state.showCopyLink){
            return this.getShareDialog();
        } else {
            return this.getCopyLInkDialog();
        }      
    }

}


export default withStyles(styles)(ShareScore);


// WEBPACK FOOTER //
// ./src/components/ShareScore.js